export default class ModalDemoCtrl {
    constructor($scope, $uibModal) {
        $scope.items = ['item1', 'item2', 'item3']

        $scope.open = function (size) {
            const modalInstance = $uibModal.open({
                templateUrl: 'myModalContent.html',
                controller: 'ModalInstanceCtrl',
                backdrop: 'static',
                size,
                resolve: {
                    items1() {
                        return $scope.items
                    },
                },
            })
        }

        $scope.toggleAnimation = function () {
            $scope.animationsEnabled = !$scope.animationsEnabled
        }
    }
}
ModalDemoCtrl.$inject = ['$scope', '$uibModal']



// WEBPACK FOOTER //
// ./src/app/system/permission/user/ModalDemoCtrl.js